import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  Radio,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const { TextArea } = Input;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [showJob, setShowJob] = useState(false);

  const [jobtypelist, setJobTypeList] = useState([]);
  const [accDictList, setAccDictList] = useState([]);
  const loadJobTypeList = async () => {
    try {
      const response = await http.get(api.getjobTypeshow);
      const data = (response.data || []).map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setJobTypeList(data);
    } catch (err) {
      console.error("Failed to load job type:", err);
    }
  };

  const loadAccDictList = async () => {
    try {
      const queryParams = { glChartNameId: "1" };

      const response = await http.get(api.getAcctDictList, {
        params: queryParams,
      });
      const list = (response.data || []).map((item) => ({
        value: item.glAcct,
        label: item.glAcctTitle,
      }));

      setAccDictList(list);
    } catch (err) {
      console.error("Failed to load account dict:", err);
    }
  };

  /** Modal 打开 */
  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      form.resetFields();
      setVisible(true);
      setShowJob(false);

      await Promise.all([loadJobTypeList(), loadAccDictList()]);
    },
  }));

  const onFinishAdd = async (values) => {
    try {
      setLoading(true);

      const queryParams = {
        name: values.name,
        description: values.description,
        parentId: values.level === "level1" ? 0 : values.jobid,
        glMonthlyWorker: values.glMonthlyWorker,
        glContractor: values.glContractor,
        monthlyWorkerV: values.monthlyWorkerV,
        contractorV: values.contractorV,
        createBy: localStorage.getItem("accountId"),
      };

      const response = await http.post(api.getjobtypeadd, queryParams);

      if (response.code === "1") {
        message.success("Add job successfully");
        setVisible(false);
        form.resetFields();
        setShowJob(false);
        onSuccess && onSuccess();
      } else {
        message.error(response.msg || "Update failed");
      }
    } catch (error) {
      message.error("Submit error, try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4}>ADD TYPE-JOB</Typography.Title>
        </Flex>
      }
      width="50%"
      open={visible}
      maskClosable={false}
      onCancel={() => {
        setVisible(false);
        setShowJob(false);
        form.resetFields();
      }}
      footer={
        <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            setShowJob(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>

        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
        </div>
      }
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              form={form}
              name="addJobForm"
              onFinish={onFinishAdd}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 16 }}
            >
              <Form.Item
                name="name"
                label="Name"
                rules={[{ required: true, message: "Please enter a name" }]}
              >
                <Input allowClear />
              </Form.Item>

              <Form.Item name="description" label="Description">
                <TextArea />
              </Form.Item>

              <Form.Item name="level" label="Level" rules={[{ required: true }]}>
                <Radio.Group
                  onChange={(e) => setShowJob(e.target.value === "level2")}
                >
                  <Radio value="level1">Level 1</Radio>
                  <Radio value="level2">Level 2</Radio>
                </Radio.Group>
              </Form.Item>

              {showJob && (
                <Form.Item
                  name="jobid"
                  label="Job Type"
                  rules={[
                    { required: true, message: "Please select job type" },
                  ]}
                >
                  <Select
                    placeholder="Select job type"
                    options={jobtypelist}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                  />
                </Form.Item>
              )}

              <Form.Item name="glMonthlyWorker" label="GL Monthly Worker">
                <Select
                  placeholder="Select glMonthlyWorker"
                  options={accDictList}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>

              <Form.Item name="glContractor" label="GL Contractor">
                <Select
                  placeholder="Select glContractor"
                  options={accDictList}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>

              <Form.Item name="monthlyWorkerV" label="Monthly Worker V">
                <Select
                  placeholder="Select monthlyWorkerV"
                  options={accDictList}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>

              <Form.Item name="contractorV" label="Contractor V">
                <Select
                  placeholder="Select contractorV"
                  options={accDictList}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;
